module.exports = __webpack_public_path__ + "static/scale-model-of-southbank-riverwalk-in-jacksonville-florida-bea1136c477f41f0a35d844bfb2ac5c8.png";